module.exports = __webpack_public_path__ + "img/header.824538e1.png";